import {ITutorialState, TutorialActions} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

export const tutorialInitialState: ITutorialState = {
    tutorials: Object.create(null),
};

export const tutorialReducer : Reducer<ITutorialState, TutorialActions> = (state = tutorialInitialState, action) => {
    switch (action.type) {
        case getType(actions.closeTutorial):
            return {
                ...state,
                tutorials: {
                    ...state.tutorials,
                    [action.payload]: true
                }
            };

        default:
            return state;
    }
};
